import React from 'react'
import { AppFC } from 'types'

export const AppGrowingContainer: AppFC = ({ children, className, ...rest }) => {
  return (
    <div {...rest} className={`w-full flex-grow-1 ${className}`}>
      {children}
    </div>
  )
}

AppGrowingContainer.defaultProps = {
  className: '',
}
